<template>
  <div>
    <Title :pages="[{ icon: 'user-tie', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="lc-loose">
        <div class="lc-list">
          <div class="lc-item my-account-user">
            <div class="lc-main">
              <div class="lc-icon-box lc-icon-box--round">{{ initials }}</div>
              <div class="lc-info">
                <div class="lc-title">{{ name }}</div>
                <div class="lc-sub">{{ email }}</div>
              </div>
            </div>
          </div>

          <v-card flat outlined class="my-account-options">
            <v-list>
              <PushNotificationsItem />
              <v-list-item @click="$router.push('/change-password')">
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-lock-reset</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Cambiar contraseña</v-list-item-title>
                </v-list-item-content>
                <v-icon small>mdi-chevron-right</v-icon>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="dialog_logout = true">
                <v-list-item-icon class="mr-3">
                  <v-icon color="red">mdi-export</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="red--text">Cerrar sesión</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </div>
    </v-container>

    <DialogYesNo :open="dialog_logout" title="Confirmar" message="¿Estas seguro que quieres cerrar sesion?" @cancel="dialog_logout = false" @accept="logout" />
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import PushNotificationsItem from "@/components/PushNotificationsItem.vue";
import { authService } from "@/libs/ws/authService";

export default {
  components: { Title, DialogYesNo, PushNotificationsItem },
  data() {
    return {
      page_title: "Mi cuenta",
      name: localStorage.getItem("name"),
      email: localStorage.getItem("email"),
      initials: authService.userInitials(),
      dialog_logout: false,
    };
  },
  methods: {
    logout() {
      authService.logOut();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
/* Sin acciones en la fila: no hace falta reservar la columna flotante de mobile */
.my-account-user {
  padding-right: 18px;
}
.my-account-options {
  border-radius: 10px;
  overflow: hidden;
}
</style>
